export const EXPECTED_RESPONSE_TIME = 24 * 60 * 60;
export const DEADLINE_GREEN_SECS = 3 * 60 * 60;
export const DEADLINE_RED_SECS = 1 * 60 * 60;

const region = process.env.AWS_REGION;
export const API_HOST = `https://${process.env.API_BASE_REST_ID}.execute-api.${region}.amazonaws.com/dev/`;

export const FILTER_DEBOUNCE = 500;
